export class ProdutoEspecialVendedor {
  public idprodutoespecialvendedor: number;
  public idprodutotabelaespecial: number;
  public idvendedor: number;
  public datainclusao: Date;
  public fullname: string;

  constructor() { }
}
